import { SecurityCategory } from '../../proto/generated/security'
import { Chip } from '@mui/material'


interface SecurityCategoryItemProps {
    category: SecurityCategory,
    selected: boolean,
    onSelected: Function,
    darkTheme: boolean,
    inputRef: any
}

export default function SecurityCategoryItem(props: SecurityCategoryItemProps) {

    const { selected } = props

    const handleMouseDown = (e: any) => {
        e.preventDefault()
        props.onSelected(props.category.code)
    }

    return <Chip sx={{ mr: 1, }} label={props.category.displayName} variant={selected?'filled':"outlined"}
                 onMouseDown={handleMouseDown} onClick={() => {
        if (!selected) {
            props.onSelected(props.category.code)
            if (props.inputRef.current) {
                props.inputRef.current.focus()
            }
        }
    }} />
}